/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { currencyFormatter } from '../../../../utils/formatting';

const ComplimentaryTender = ({
  tenderInfo
}) => {
  const {
    isAdmin, redacted, RL_CompNo, RL_ComplimentaryDetail, RL_PurchaserName, RL_Requestedby, RL_Department1, RL_Reason3, locale: { storeCurrency, storeLocale }
  } = useSelector((state) => state);
  return (
    <>
      <article className="justify-between">
        <p>{RL_ComplimentaryDetail}</p>
        <p>
          {currencyFormatter(
            storeLocale,
            storeCurrency,
            tenderInfo.Tender?.Amount?.Amount || ''
          )}
        </p>
      </article>
      <article className="justify-between">
        <p className="pl4-sm">{RL_CompNo}.: {isAdmin ? (tenderInfo.Tender?.ComplimentaryTender?.Account || '') : redacted}</p>
      </article>
      <article className="justify-between">
        <p className="pl6-sm">{RL_PurchaserName}: {isAdmin ? (tenderInfo.Tender?.ComplimentaryTender?.Purchaser || '') : redacted}</p>
      </article>
      <article className="justify-between">
        <p className="pl4-sm">{RL_Requestedby}: {isAdmin ? (tenderInfo.Tender?.ComplimentaryTender?.RequestedBy || '') : redacted}</p>
      </article>
      <article className="justify-between">
        <p className="pl4-sm">{RL_Department1}: {(tenderInfo.Tender?.ComplimentaryTender?.Department || '')}</p>
      </article>
      <article className="justify-between">
        <p className="pl2-sm">{RL_Reason3} {(tenderInfo.Tender?.ComplimentaryTender?.Reason || '')}</p>
      </article>
      <br />
    </>
  );
};

ComplimentaryTender.defaultProps = {
  tenderInfo: {},
};

ComplimentaryTender.propTypes = {
  tenderInfo: PropTypes.shape(),
};

export default ComplimentaryTender;
